module.exports = __webpack_public_path__ + "img/rating.ae13ba55.svg";